(function () {
(function($) {
    Drupal.behaviors.PastEvent = {
        attach: (context, settings)=>{}
    };
    $(function() {
        hkust_sa_handle_past_event_image_lazyload();
        hkust_sa_handle_past_event_image_masonry();
        hkust_sa_handle_past_event_prev_event();
        hkust_sa_handle_past_event_next_event();
        hkust_sa_handle_image_display();
        hkust_sa_handle_image_hide();
        hkust_sa_handle_window_scroll();
        imageAnimation();
    });
    function hkust_sa_handle_past_event_image_lazyload() {
        $(".lazy").Lazy({
            scrollDirection: "vertical",
            effect: "fadeIn",
            visibleOnly: true
        });
    }
    function hkust_sa_handle_past_event_image_masonry() {
        var grid = buildMasonry();
        masonryCheckPosition();
        $(window).resize(function() {
            grid.masonry("layout");
            masonryCheckPosition();
        });
        $(document).ajaxComplete(function() {
            grid.masonry("destroy");
            grid = buildMasonry();
            masonryCheckPosition();
        });
    }
    function buildMasonry() {
        return $(".view-ustsa-past-event .ustsa-past-event__image").masonry({
            // options...
            itemSelector: "article",
            gutter: 20
        });
    }
    function masonryCheckPosition() {
        if ($(".view-ustsa-past-event .ustsa-past-event__image article").length == 0) return;
        $(".view-ustsa-past-event .ustsa-past-event__image article").each(function() {
            if (parseInt($(this).css("left"), 10) > 0) {
                $(this).removeClass("masonry-left");
                $(this).addClass("masonry-right");
            } else {
                $(this).removeClass("masonry-right");
                $(this).addClass("masonry-left");
            }
        });
    }
    function hkust_sa_handle_past_event_prev_event() {
        var id = $(".ustsa-past-event__id").data("id");
        var date = $(".ustsa-past-event__date").data("date");
        $.ajax({
            url: `/api/prev-past-event?date=${date}&id=${id}`,
            accepts: "application/json; charset=utf-8"
        }).then(function(data) {
            $(".link-prev").each(function() {
                if (data.length > 0) $(this).children("a").attr("href", data[0]["url"]);
            });
        });
    }
    function hkust_sa_handle_past_event_next_event() {
        var id = $(".ustsa-past-event__id").data("id");
        var date = $(".ustsa-past-event__date").data("date");
        $.ajax({
            url: `/api/prev-next-event?date=${date}&id=${id}`,
            accepts: "application/json; charset=utf-8"
        }).then(function(data) {
            $(".link-next").each(function() {
                if (data.length > 0) $(this).children("a").attr("href", data[0]["url"]);
            });
        });
    }
    function hkust_sa_handle_image_display() {
        $(".ustsa-past-event__image .ustsa-past-event__image_item").on("click", function() {
            var slideShowSelector = $(".image-layer .mtpc-block-slideshow-block .slick_slideshow");
            var key = $(this).index();
            $(".image-layer").show();
            slideShowSelector.css("opacity", 0);
            mtpc_initSlick(slideShowSelector, key);
            slideShowSelector.slick("slickGoTo", key);
            slideShowSelector.on("afterChange", function() {
                slideShowSelector.css("opacity", 1);
            });
        });
    }
    function hkust_sa_handle_image_hide() {
        $(".image-layer .cnt_close_menu_button").on("click", function() {
            $(this).parents(".image-layer").hide();
            var slideShowSelector = $(".image-layer .mtpc-block-slideshow-block .slick_slideshow");
            slideShowSelector.slick("unslick");
        });
    }
    function mtpc_initSlick(slideShowSelector) {
        var slideShowSelector = $(".image-layer .mtpc-block-slideshow-block .slick_slideshow");
        // Check if Slick selector exists in the DOM
        if (slideShowSelector.length > 0) slideShowSelector.each(function() {
            // Init slick if not initiated
            $(this).not(".slick-initialized").slick();
            // Hide slide dots if only one slide
            var total = $(this).find(".slideshow_item").length;
            if (total <= 1) $(this).addClass("forceHideDots");
            $(this).on("init reInit afterChange", function(event, slick, currentSlide) {
                $(".image-layer .mtpc-block-slideshow-block .slick-qty").html(`<p>${currentSlide + 1} / ${total}</p>`);
            });
        });
    }
    function hkust_sa_handle_window_scroll() {
        let windowScrollTop = $(window).scrollTop();
        let headerHeight = $("header").height();
        let eventHeight = $(".ustsa-past-event").height();
        let eventInfoHeight = $(".ustsa-past-event__info").height();
        let scrolledTop = windowScrollTop - headerHeight;
        let thumbHalf = $(".ustsa-past-event__thumb img").height() / 2;
        if (scrolledTop > 0) {
            if (eventHeight - scrolledTop > eventInfoHeight) {
                $(".ustsa-past-event > .ustsa-past-event__link-prev").css("top", scrolledTop + thumbHalf + "px");
                $(".ustsa-past-event > .ustsa-past-event__link-next").css("top", scrolledTop + thumbHalf + "px");
            }
        }
        if (scrolledTop <= 0) {
            $(".ustsa-past-event > .ustsa-past-event__link-prev").css("top", thumbHalf + "px");
            $(".ustsa-past-event > .ustsa-past-event__link-next").css("top", thumbHalf + "px");
        }
        $(window).on("scroll", function() {
            windowScrollTop = $(window).scrollTop();
            headerHeight = $("header").height();
            eventHeight = $(".ustsa-past-event").height();
            eventInfoHeight = $(".ustsa-past-event__info").height();
            scrolledTop = windowScrollTop - headerHeight;
            thumbHalf = $(".ustsa-past-event__thumb img").height() / 2;
            if (scrolledTop > 0) {
                if (eventHeight - scrolledTop > eventInfoHeight) {
                    $(".ustsa-past-event__info").css("top", scrolledTop + "px");
                    $(".ustsa-past-event > .ustsa-past-event__link-prev").css("top", scrolledTop + thumbHalf + "px");
                    $(".ustsa-past-event > .ustsa-past-event__link-next").css("top", scrolledTop + thumbHalf + "px");
                }
            }
            if (scrolledTop <= 0) {
                $(".ustsa-past-event__info").css("top", "unset");
                $(".ustsa-past-event > .ustsa-past-event__link-prev").css("top", thumbHalf + "px");
                $(".ustsa-past-event > .ustsa-past-event__link-next").css("top", thumbHalf + "px");
            }
        });
    }
    function imageAnimation() {
        setTimeout(()=>{
            $(".ustsa-past-event__image_item img").css({
                "top": "0px",
                "opacity": "1"
            });
        }, 300);
    }
})(jQuery);

})();
//# sourceMappingURL=node--view--ustsa-past-event.js.map
